import randomValue from './RandomValue';

export function FixStringParser(fix: string) {
    const elements = fix.split(',');
    let finalPositions = [];
    let fixString = '';

    for (var i = 0; i < elements.length; i++) {
        if (elements[i].includes('-')) {
            const range = elements[i].split('-');
            const position = randomValue(Number(range[0]), Number(range[1]));
            finalPositions.push(position);
        } else {
            const spinFix = elements[i] === 'NORMAL' ? 0 : elements[i];
            finalPositions.push(spinFix);
        }
    }

    finalPositions.forEach((element, index) => {
        fixString = fixString + element + (index !== finalPositions.length - 1 ? ',' : '');
    });

    return fixString;
}
